export const STRIPE_SUBSCRIPTIONS_CHANNEL = 'Stripe::SubscriptionsChannel'
export const PERSONAL_MESSAGE_NOTIFICATIONS_CHANNEL =
  'PersonalMessageNotificationsChannel'
export const AGORA_CHANNEL = 'AgoraChannel'
export const MENTORS_MATCHING_EXPLANATION_CHANNEL = 'MatchChannel'
export const PROFILE_CHANNEL = 'ProfileChannel'
export const INSTANT_SESSIONS_CHANNEL = 'InstantSessionsChannel'
